export const DefaultNavigationConfig = {
  'analytics.analytics': true,
  'analytics.live_vessel': true,
  'analytics.live_terminal': true,
  'analytics.bunker_analysis_group': true,
  'port-expense.agent_soa': true,
  'database.database': true,
  'database.company': true,
  'database.department': true,
  'database.bank': true,
  'database.user': true,
  'database.vessel_group': true,
  'database.cargo': true,
  'database.port': true,
  'database.location': true,
  'port-expense.port-expense': true,
  'port-expense.da_management_group': true,
  'port-expense.owners_account_group': true,
  'port-operation.port-operation': true,
  'port-operation.ctm_group': true,
  'port-operation.port_call_group': true,
  'port-operation.terminal_demurrage': true,
  'chartering-and-ops.chartering-and-ops': true,
  'chartering-and-ops.vessel_schedule': true,
  'chartering-and-ops.voyage_charter_group': true,
  'chartering-and-ops.vc_invoice_group': true,
  'chartering-and-ops.time_charter_group': true,
  'chartering-and-ops.tc_invoice_group': true,
  'chartering-and-ops.vessel_report_chartering_group': true,
  'chartering-and-ops.inventory_supply': true,
  'chartering-and-ops.bunker_supply_group': true,
  'ship-shore-operation.ship-shore-operation': true,
  'ship-shore-operation.vessel_call_group': true,
  'ship-shore-operation.pre_arrival_notice': true,
  'ship-shore-operation.pre_berth_questionnaire': true,
  'ship-interface.ship-interface': true,
  'ship-interface.itinerary': true,
  'ship-interface.vessel_report_ship_interface_group': true,
  'ship-interface.time_sheet_sof': true,
  'ship-interface.requisitions_group': true,
  'billing.billing': true,
  'billing.approval_board_owner': true,
  'billing.approval_board_elxa': true,
  'billing.invoice_management_group': true,
  'billing.elxa_invoices_group': true,
  'billing.exchange_rate': true,
  'billing.payments_group': true,
  'billing.credit_balance': true,
  'elxa-controls.elxa-controls': true,
  'elxa-controls.ctm_controls_group': true,
  'elxa-controls.port_expense_controls_group': true,
  'elxa-controls.pre_berth_questionnaire_form': true,
  'elxa-controls.xero_controls_group': true,
  'elxa-controls.subscriptions': true
};

export interface RemoteConfigKeys {
  maintenance_mode: boolean;
  sidebar_version: 1 | 2;
  language: 0 | 1;
  notification: 0 | 1;
  theme: 0 | 1;
  navigation: typeof DefaultNavigationConfig;
}

export const RemoteConfigDefaults: { [K in keyof RemoteConfigKeys] } = {
  maintenance_mode: false,
  sidebar_version: 1,
  language: 0,
  notification: 0,
  theme: 0,
  navigation: DefaultNavigationConfig
};
